export default "__VITE_ASSET__D9XhsX8m__"